module.exports = __webpack_public_path__ + "img/Good Student Award 3.92511e05.png";